export default function (number, total) {
  const num = Math.floor((number / total) * 100);
  return num;
}